export default __webpack_public_path__ + "static/media/monthly_monsta_image.fe3892aa.png";